import {HTTP, ERROR} from '@/http-common';
import Router from '@/router';
import Vue from 'vue';

const state = {
  workspace: {
    organization_forms: [],
    general_forms: [],
    showLoading: true,
  },
  shared_files: [],
  shared_files_count: 0,
  public_files: [],
  public_files_count: 0
};

const mutations = {
  SET_WORKSPACE_GENERAL_FORMS(state, data) {
    state.workspace.general_forms = data
  },
  SET_WORKSPACE_ORGANIZATION_FORMS(state, data) {
    state.workspace.organization_forms = data
  },
  SET_LOADING(state, data) {
    state.workspace.showLoading = data;
  },
  RESET_FORMS(state) {
    state.workspace.general_forms = [];
    state.workspace.organization_forms = [];
  },
  SET_SHARED_FILES(state, data) {
    state.shared_files = data;
  },
  SET_SHARED_FILES_COUNT(state, data) {
    state.shared_files_count = data;
  },
  SET_PUBLIC_FILES(state, data) {
    state.public_files = data;
  },
  SET_PUBLIC_FILES_COUNT(state, data) {
    state.public_files_count = data;
  }

};

const getters = {
  getWorkspace: state => {
    return state.workspace;
  },
  getWorkspaceLoading: state => {
    return state.workspace.showLoading;
  },
  getWorkspaceSharedFiles: state => {
    return state.shared_files;
  },
  getWorkspaceSharedFilesCount: state => {
    return state.shared_files_count;
  },
  getWorkspacePublicFiles: state => {
    return state.public_files;
  },
  getWorkspacePublicFilesCount: state => {
    return state.public_files_count;
  }
};

const actions = {
  loadWorkspace: ({commit}) => {
    commit('SET_LOADING', true);
    HTTP.post('workspace/get-forms')
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_WORKSPACE_GENERAL_FORMS', response.data.data.organization_general);
          commit('SET_WORKSPACE_ORGANIZATION_FORMS', response.data.data.organization_organization);
          commit('SET_LOADING', false);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
          Router.push({name: 'Organization Forms'});
        }
      }).catch(err => {
      console.log(err);
    })
  },
  loadWorkspaceSharedFiles: ({commit}, payment) => {
    commit('SET_LOADING', true);
    HTTP.post('workspace/shared-files/', payment)
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_SHARED_FILES', response.data.data.files);
          commit('SET_SHARED_FILES_COUNT', response.data.data.files_count);
          commit('SET_LOADING', false);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
          // Router.push({name: 'Shared files'});
        }
      }).catch(err => {
      console.log(err);
    })
  },
  loadWorkspacePublicFiles: ({commit}, payment) => {
    commit('SET_LOADING', true);
    HTTP.post('workspace/public-files/', payment)
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_PUBLIC_FILES', response.data.data.files);
          commit('SET_PUBLIC_FILES_COUNT', response.data.data.files_count);
          commit('SET_LOADING', false);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
          // Router.push({name: 'Public files'});
        }
      }).catch(err => {
      console.log(err);
    })
  }
};
export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/workspace.js